import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Form } from 'react-bootstrap';
import { Button } from "@app/components";
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { setStep } from '@app/store/reducers/enrollmentForm';

const EnrollmentStep2 = (props) => {
        
    const enrollmentStore = useSelector((state: any) => state.enrollmentForm);
    const [isLoading, setLoading] = useState(false);
    const dispatch = useDispatch();
    
    useEffect(() => {
    
        return () => {

        }
    },[]);
    

    const { handleChange, values, handleSubmit, touched, errors, setFieldValue } = useFormik({
        initialValues: {
            step: 2,
            parent_first_name: enrollmentStore?.formData?.parent_first_name || '',
            parent_last_name: enrollmentStore?.formData?.parent_last_name || '',
            parent_email: enrollmentStore?.formData?.parent_email || '',
            parent_phone: enrollmentStore?.formData?.parent_phone || '',
            address: enrollmentStore?.formData?.address || '',
            postcode: enrollmentStore?.formData?.postcode || ''
        },
        validationSchema: Yup.object({
            parent_first_name: Yup.string().trim().required('Please enter first name'),
            parent_last_name: Yup.string().trim().required('Please enter last name'),
            parent_email: Yup.string().trim().email().required('Please enter email'),
            parent_phone: Yup.string().required('Please enter contact number')
            .matches(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
                "Please enter valid number"
            ),
            address: Yup.string().trim().required('Please enter address'),
            postcode: Yup.string().trim().required('Please enter postcode'),
        }),
        onSubmit: (values) => {
            props?.updateEnrollmentDetailsAPI(values)
        },
        enableReinitialize: true,
    });
    
    return (
        <>
        <Form onSubmit={handleSubmit}>
        <div className="content mb-3">
            <h6 className="mb-4 grey_wrapper_title"><i className="fas fa-user"/> &nbsp; Parent/Guardian Details </h6>
            <div className="content_inner_wrap">
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1">First Name <span className="required">*</span></label>
                            <input type="text" className="form-control" id="exampleInputEmail1" placeholder="Enter first name" 
                                name="parent_first_name" 
                                onChange={handleChange} 
                                value={values.parent_first_name}
                            />
                            {(touched.parent_first_name && errors.parent_first_name) && (
                                <div className="text-danger">
                                    {errors.parent_first_name}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Last Name <span className="required">*</span></label>
                            <input type="text" className="form-control" id="exampleInputEmail1" placeholder="Enter last name" 
                                name="parent_last_name" 
                                onChange={handleChange} 
                                value={values.parent_last_name}
                            />
                            {(touched.parent_last_name && errors.parent_last_name) && (
                                <div className="text-danger">
                                    {errors.parent_last_name}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="exampleInputGuardianEmail">Email <span className="required">*</span></label>
                            <Form.Control 
                                type="email" 
                                className="form-control" 
                                id="exampleInputGuardianEmail" 
                                placeholder="Enter email"
                                name="parent_email" 
                                onChange={handleChange} 
                                value={values.parent_email}
                                disabled
                            />
                            {(touched.parent_email && errors.parent_email) && (
                                <div className="text-danger">
                                    {errors.parent_email}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="exampleInputGuardianContactNo">Contact Number (WhatsApp Number) <span className="required">*</span></label>
                            <Form.Control 
                                type="number" 
                                className="form-control" 
                                id="exampleInputGuardianContactNo" 
                                placeholder="Enter contact number"
                                name="parent_phone" 
                                onChange={handleChange} 
                                value={values.parent_phone}
                                disabled
                            />
                            {(touched.parent_phone && errors.parent_phone) && (
                                <div className="text-danger">
                                    {errors.parent_phone}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="exampleInputAddress">Home Address <span className="required">*</span></label>
                            <textarea 
                                className="form-control" 
                                id="exampleInputAddress" 
                                placeholder="Enter address" 
                                name="address" 
                                onChange={handleChange} 
                                value={values.address}
                            ></textarea>
                            {(touched.address && errors.address) && (
                                <div className="text-danger">
                                    {errors.address}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="exampleInputPostcode">Postcode <span className="required">*</span></label>
                            <Form.Control 
                                type="text" 
                                className="form-control" 
                                id="exampleInputPostcode" 
                                placeholder="Enter postcode"
                                name="postcode" 
                                onChange={handleChange} 
                                value={values.postcode}
                            />
                            {(touched.postcode && errors.postcode) && (
                                <div className="text-danger">
                                    {errors.postcode}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="mx-4 d-flex justify-content-between align-items-center">
            <Button type="button" isLoading={isLoading} onClick={ () => dispatch(setStep(enrollmentStore?.step - 1))} className="btn btn-default"> Back </Button>
            <Button type="submit" isLoading={isLoading} className="btn btn-primary "> Next </Button>
        </div>
        </Form>
        </>
    );
};

export default EnrollmentStep2;